class OpalWoocommerceSingleProduct {
    constructor() {
        this.initSlideProduct();
    }

    initSlideProduct() {
        let lightbox = $('.single-product .woocommerce-product-gallery__image > a');
        if (lightbox.length) {
            lightbox.attr("data-elementor-open-lightbox", "no");
        }
    }
}

new OpalWoocommerceSingleProduct();